export var MONITOR_TYPE = {
  RPC: 811,
  LOG: 812,
  SPEED: 813,
  PV: 814,
  IMG_SPEED: 815,
  INDEX_SPEED: 816,
  PAGE_SPEED: 817,
  PAGE_STAY_TIME: 818
};
export var RANDOM = Math.floor(Math.random() * 10000000000000000);
export var MAX_TIME = 60000;
export var MIN_TIME = 0;
export var KEYS = ['navigationStart',
// 0 从同一个浏览器上下文的上一个文档卸载(unload)结束时的时间戳。如果没有上一个文档，这个值会和fetchStart相同。我试了几个打开方式，发现都不能和fetchStart相等。
'unloadEventStart',
// 1 如果前一个文档和当前文档同源,返回前一个文档开始unload的时间
'unloadEventEnd',
// 2 如果前一个文档和当前文档同源,返回前一个文档开始unload结束的时间
'redirectStart',
// 3 如果有重定向,这里是重定向开始的时间.
'redirectEnd',
// 4 如果有重定向,这里是重定向结束的时间.
'fetchStart',
// 5 网页请求发起

'domainLookupStart',
// 6 查询DNS
'domainLookupEnd',
// 7 查询DNS结束

'connectStart',
// 8 建立TCP链接开始
'connectEnd',
// 9 建立TCP链接结束

'secureConnectionStart',
// 10 用于计算 SSL 连接耗时，没有用https，返回0

'requestStart',
// 11 request
'responseStart',
// 12 response
'responseEnd',
// 13 处理响应结束

'domLoading',
// 14 DOM开始加载
'domInteractive',
// 15 DOM可交互，文档解析结束的时间
'domContentLoadedEventStart',
// 16 DOM 事件开始，DOMContentLoaded开始
'domContentLoadedEventEnd',
// 17 DOM 事件结束，DOMContentLoaded结束
'domComplete',
// 18 DOM加载完成

'loadEventStart',
// 19 触发 onload事件，网络页面加载事件开始，未触发加载事件，返回0
'loadEventEnd' // 20 网络页面加载事件结束，未触发加载结束事件，返回0
];